import { CLASS_STATUS, PAYMENT_STATUS } from "@/lib/format";

const TONES = {
  agendada: "bg-blue-500/15 text-blue-600 dark:text-blue-400",
  confirmada: "bg-primary/15 text-primary",
  realizada: "bg-emerald-500/15 text-emerald-600 dark:text-emerald-400",
  cancelada: "bg-rose-500/15 text-rose-600 dark:text-rose-400",
  faltou: "bg-orange-500/15 text-orange-600 dark:text-orange-400",
  pago: "bg-emerald-500/15 text-emerald-600 dark:text-emerald-400",
  pendente: "bg-amber-500/15 text-amber-600 dark:text-amber-400",
  atrasado: "bg-rose-500/15 text-rose-600 dark:text-rose-400",
  cancelado: "bg-muted text-muted-foreground",
  ativo: "bg-emerald-500/15 text-emerald-600 dark:text-emerald-400",
  inativo: "bg-muted text-muted-foreground",
  concluido: "bg-blue-500/15 text-blue-600 dark:text-blue-400",
  active: "bg-emerald-500/15 text-emerald-600 dark:text-emerald-400",
  blocked: "bg-rose-500/15 text-rose-600 dark:text-rose-400",
};
const LABELS = { ...CLASS_STATUS, ...PAYMENT_STATUS, ativo: "Ativo", inativo: "Inativo", concluido: "Concluído", active: "Ativa", blocked: "Bloqueada" };

export const StatusBadge = ({ status, testId }) => (
  <span
    className={`inline-flex items-center whitespace-nowrap rounded-full px-2.5 py-0.5 text-xs font-semibold ${TONES[status] || "bg-muted"}`}
    data-testid={testId || `status-badge-${status}`}
  >
    {LABELS[status] || status}
  </span>
);
